import React from 'react'
import fbMessengerLink from 'fb-messenger-link'
import { ReactComponent as MessengerIcon } from '../../../../../../assets/messenger.svg'
import Button from './Button'

export default ({ facebookAppId, url }) => (
  <Button
    href={fbMessengerLink(facebookAppId)(url)}
    icon={MessengerIcon}
    hideOnDesktop
    style={{
      width: '24px',
      height: '24px',
      marginTop: '-3px',
    }}
  />
)
